import { Box, CircularProgress } from "@mui/material";

import { InstagramAccountOverview } from "../InstagramAccountOverview";
import { InstagramConnectHero } from "../InstagramConnectHero";
import type { SettingsInstagramPanelProps } from "./SettingsInstagramPanel.types";
import * as styles from "./SettingsInstagramPanel.styles";

export type { SettingsInstagramPanelProps } from "./SettingsInstagramPanel.types";

export function SettingsInstagramPanel({
  variant = "panel",
  state,
  account,
  ...connection
}: SettingsInstagramPanelProps) {
  if (state === "loading") {
    return (
      <Box sx={styles.loading}>
        <CircularProgress size={32} />
      </Box>
    );
  }

  if (!account) {
    return <InstagramConnectHero variant={variant} {...connection} />;
  }

  return (
    <InstagramAccountOverview
      account={account}
      needsAttention={state === "attention"}
      {...connection}
    />
  );
}
